import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { map } from 'rxjs/operators';

import { ModalService } from '../services/modal.service';
import { firstWithContext } from '../utils/first-with-context';
import { HasChanges } from './has-changes';

@Injectable({
  providedIn: 'root',
})
export class PendingChangesGuard {
  static showModal(modalService: ModalService) {
    return modalService
      .showQuestionModal(
        'There are unsaved changes. Do you want to exit without saving?',
        'Pending changes',
      )
      .pipe(
        map(() => true),
        firstWithContext(null, false),
      );
  }

  static skipCheck(component: HasChanges, navigationPromise: Promise<boolean>) {
    PendingChangesGuard.skip = component;
    navigationPromise.then(
      () => (PendingChangesGuard.skip = null),
      () => (PendingChangesGuard.skip = null),
    );
  }

  private static skip: HasChanges | null = null;

  constructor(private modalService: ModalService) {}

  canDeactivate(
    component: HasChanges,
    _currentRoute: ActivatedRouteSnapshot,
    _currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot,
  ) {
    if (PendingChangesGuard.skip === component) {
      return true;
    }

    // Does the next route include a '-' part
    if (nextState && /\/\-(?:\/|$)/.test(nextState.url)) {
      return true;
    }

    if (component.hasChanges) {
      return PendingChangesGuard.showModal(this.modalService);
    }

    return true;
  }
}
